import styled from 'styled-components';

export const Container = styled.label`
  width: 100%;

  .react-select__control {
    min-height: 30px;
    background: #e9ebee;
    border-radius: 5px;
    padding: 0 6px;
    font-size: 14px;
    border: 0 !important;
    color: #858f9e !important;
    box-shadow: none !important;

    max-height: 88px;
    overflow-y: auto;

    border: ${({ hasError }) => hasError && `2px solid #dc3545!important`};
  }

  .react-select__value-container,
  .react-select__value-container--is-multi {
    padding: 0;
  }

  .react-select__indicator,
  .react-select__dropdown-indicator {
    padding: 2px;
  }

  .react-select__single-value {
    color: #858f9e;
  }

  .react-select__multi-value {
    background: #a8b1bf;
    border-radius: 12px;
    padding: 0 6px;
  }

  .react-select__multi-value__label {
    color: #fff;
    font-size: 14px;
  }

  .react-select__multi-value__remove {
    color: #fff;
    border-radius: 12px;
    cursor: pointer;

    &:hover {
      background: #a8b1bf;
      color: #ddd;
    }
  }

  .react-select__input input {
    color: #858f9e !important;
  }

  .react-select__indicator-separator {
    display: none;
  }
  .react-select__dropdown-indicator {
    color: #515f75;
  }
  .react-select__dropdown-indicator svg {
    height: 12px;
  }
  .react-select__clear-indicator {
    color: #515f75;
  }
  .react-select__clear-indicator svg {
    height: 12px;
    width: 16px;
  }

  .react-select__menu {
    font-size: 14px;
    word-break: break-word;
  }

  .react-select__menu-list {
    border-radius: 4px;
    max-height: 220px !important;
  }

  .react-select__option {
    color: #858f9e;
    font-size: 14px;
    padding: 4px 6px;

    &:active {
      background: #a8b1bf !important;
      color: #fff;
    }
  }

  .react-select__option--is-focused {
    background: #dde9fb;
  }

  .react-select__option--is-selected {
    background: #a8b1bf;
    color: #fff;
  }

  .react-select__group-heading {
    padding-left: 6px;
  }

  @media only screen and (max-height: 800px) {
    .react-select__menu-list {
      max-height: 120px !important;
    }
  }
`;
